module.exports = __webpack_public_path__ + "media/images/share-917a6f67.png";